define('views/root/root',[
	'backbone',
	'views/_base/baseview',
	'text!views/root/root.html',
	'views/root/split_pano',
], function (Backbone, BaseView, Template, SplitPanoComponent) {
	'use strict';

	return BaseView.extend({
		tagName: 'div',
		className: 'register-container fullWidth againstHeader againstFooter',
		template: _.template(Template),
		isRender: true,
		needsAuth: false,
		events: {},

		initialize: function (options) {
			options = options || {};

			this.email_guid = options.GUID;
			this.email_verification_code = options.VerificationCode;

			this.site_version = pf.getContent('version.id');

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this, options);
		},

		render: function () {
			this.$el.html(this.template());

			if (this.email_guid) {
				this.verifyEmailAddress();
			}

			// Add Pano
			this.addSplitPano();

			return this;
		},

		verifyEmailAddress: function () {
			var data = null,
				success = false,
				that = this;

			$.ajax({
				type: 'GET',
				url: pf.url + '/EmailVerification',
				data: {
					EmailGUID: this.email_guid,
					VerificationCode: this.email_verification_code,
				},
				async: false,
				contentType: 'application/json',
				success: function (response) {
					success = true;
					that.ResponseType = 'S';
					that.emailConfirmationView();
				},
				error: function (response) {
					that.ResponseType = 'F';
				},
			});
		},

		emailConfirmationView: function () {
			pfdialog.alert({
				Title: 'Email Verified',
				Body: 'Thank you for confirming your email address',
				okCallback: function () {
					pf.navigate('');
				},
			});
		},

		addSplitPano: function () {
			var pano = new SplitPanoComponent({ elementName: '.js-pano-container' });
		},

		close: function () {},
	});
});

